import { createTheme } from "@mui/material/styles";
import ParkkiTheme from "./ParkkiTheme";

const ParkkiMuiTheme = createTheme({
  palette: {
    primary: {
      main: ParkkiTheme.colors.turquoise,
    },
    secondary: {
      main: ParkkiTheme.colors.turquoise3,
    },
  },
  typography: {
    fontFamily: '"Source Sans Pro", sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: `
        @font-face {
          font-family: '"Source Sans Pro", sans-serif',
        }
      `,
    },
  },
});

export default ParkkiMuiTheme;
